<!--<div class="container">-->
<!--  <div class="row">-->
<!--    <div class="col-12">-->
<!--&lt;!&ndash;      <label for="user_avatar">{{ 'UploadImage' | translate}}</label>&ndash;&gt;-->
<!--      <input type="file" id="user_avatar" (change)="fileChangeEvent($event)">-->
<!--    </div>-->
<!--    <div class="col2_edit_info" *ngIf="showEditPic">-->
<!--      <div class="row">-->
<!--        <div class="col-6">-->
<!--          <image-cropper-->
<!--            [imageChangedEvent]="imageChangedEvent"-->
<!--            [maintainAspectRatio]="true"-->
<!--            [aspectRatio]="3 / 3"-->
<!--            [resizeToWidth]="300"-->
<!--            format="png"-->
<!--            (imageCropped)="imageCropped($event)"-->
<!--            (imageLoaded)="imageLoaded()"-->
<!--            (cropperReady)="cropperReady()"-->
<!--            (loadImageFailed)="loadImageFailed()"-->
<!--          ></image-cropper>-->
<!--        </div>-->
<!--        <div class="col-6">-->
<!--          <img [src]="pomodoroRepository.profilePhoto">-->
<!--        </div>-->
<!--        <button class="btn btn-danger" (click)="updateProfileWithImg()">ثبت</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<div class="fsp-content" *ngIf="step1">
  <div class="fsp-drop-area-container">
    <div tabindex="0" class="fsp-drop-area">
      <div class="fsp-select-labels">
        <div class="fsp fsp-drop-area__title fsp-text__title"> Select Files to Upload</div>
        <div class="fsp fsp-drop-area__subtitle fsp-text__subheader"> or Drag and Drop, Copy and Paste Files</div>
      </div>
      <input type="file" id="user_avatar" (change)="fileChangeEvent($event)"></div>
  </div>
</div>
<div class="fsp-content" *ngIf="step2">
  <div class="fsp-drop-area-container">
              <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="3 / 3"
                [resizeToWidth]="300"
                format="png"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()"
                (cropperReady)="cropperReady()"
                (loadImageFailed)="loadImageFailed()"
              ></image-cropper>
    <div class="clearfix"></div>
  </div>
  <button class="confirm" (click)="updateProfileWithImg()">
    ثبت
    <mat-spinner style="vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="accent" *ngIf="uploadSpinner"></mat-spinner>
  </button>
</div>
